import { toast } from 'react-toastify';
import { put, call, takeEvery } from 'typed-redux-saga';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';

export default function* watchGetStockOutsTransactions(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldGetStockOutsTransactionsAttempt', handleGetStockOutsTransactions, api);
}

function* handleGetStockOutsTransactions(api: GoldGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;

    const {
        productId,
        amount,
        // serialNoId,
    } = reduxState.gold.goldInventory.inventoryStockOutTransactionsListing.filters ?? {};

    const response = yield* call([api, api.getStockOutTransactionsListing], {
        authToken,
        productId: productId ? productId : undefined,
        amount: amount ? amount : undefined,
        // serialNoId: serialNoId ? serialNoId : undefined,

    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.goldGetStockOutsTransactionsFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(
            combinedActions.goldGetStockOutsTransactionsSuccess(response.data)
        );

        const {
            affectedTransactions,
            affectedEarmarks,
            affectedConversions,
            affectedCollaterals,
            affectedEarmarkConversions,
        } = response.data;

        const hasAffectedRecords =
            affectedTransactions.length > 0 ||
            affectedEarmarks.length > 0 ||
            affectedConversions.length > 0 ||
            affectedCollaterals.length > 0 ||
            affectedEarmarkConversions.length > 0;

        if (hasAffectedRecords) {
            yield put(
                combinedActions.goldSetIsStockOutTransactionsModalOpen(true)
            );
        } else {
            yield put(
                combinedActions.goldCreateStockOutAttempt()
            );
        }
    }
}
